import { render, staticRenderFns } from "./PaymentHeader.vue?vue&type=template&id=7f23e7d5&scoped=true"
import script from "./PaymentHeader.vue?vue&type=script&lang=js"
export * from "./PaymentHeader.vue?vue&type=script&lang=js"
import style0 from "./PaymentHeader.vue?vue&type=style&index=0&id=7f23e7d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f23e7d5",
  null
  
)

export default component.exports